import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import Select, { components } from "react-select";

const SelectDropdown = ({
  name,
  placeholder,
  options,
  required,
  handleOnChange,
  index,
  isSearchable = true,
  defaultValue,
  errorMessage = "",
  forceEnglishFont = false,
}) => {
  // const [selectedValue, setSelectedValue] = useState(defaultValue);
  const { i18n } = useTranslation();
  const currentLanguage = i18n.language;

  // useEffect(() => {
  //   if (defaultValue && options) {
  //     const value = options.find(
  //       (option) => option.value === defaultValue.value
  //     );
  //     setSelectedValue(value);
  //   } else {
  //     setSelectedValue(defaultValue);
  //   }
  // }, [defaultValue, options]);

const selectedValue = options?.find(
  (option) => option.value === defaultValue?.value
);

  return (
    <>
    <Select
      name={name}
      options={options}
      required={required}
      onChange={(e) => {
        handleOnChange(name, e?.value, index, e?.label);
      }}
      placeholder={placeholder}
      value={selectedValue}
      isSearchable={isSearchable}
      filterOption={(option, inputValue) => {
        if (!inputValue) return true; // show all when nothing typed
        return option.label.toLowerCase().startsWith(inputValue.toLowerCase());
      }}
      className="react-select-container"
      classNamePrefix="react-select"
      components={{
        DropdownIndicator: (props) => (
          <components.DropdownIndicator {...props}>
            <i
              className="bi bi-chevron-down"
              size={16}
              style={{
                color: "#525658",
                transition: "transform 0.2s ease",
                transform: props.selectProps.menuIsOpen
                  ? "rotate(180deg)"
                  : "rotate(0deg)",
              }}
            ></i>
          </components.DropdownIndicator>
        ),
      }}
      styles={{
        control: (provided) => ({
          ...provided,
          backgroundColor: "#e7e7e7",
          border: "none",
          borderRadius: "10px",
          height: "50px",
          fontSize: "16px",
          fontWeight: 600,
          width: "100%",
          boxShadow: "none",
          textTransform: "capitalize",
          direction: forceEnglishFont ? "ltr" : undefined,
          fontFamily: '"Montserrat", serif',
          "&:hover": {
            borderColor: "#e7e7e7",
          },
        }),
        option: (provided, state) => ({
          ...provided,
          backgroundColor: state.isFocused ? "#ffb63e" : "#fff",
          color: state.isFocused ? "#fff" : "#6f6f6f",
          fontSize: "16px",
          fontWeight: 600,
          textTransform: "capitalize",
          cursor: "pointer",
          direction: forceEnglishFont ? "ltr" : undefined,
          fontFamily: '"Montserrat", serif',
        }),
        input: (provided) => ({
          ...provided,
          fontSize: "16px",
          fontWeight: 600,
          textTransform: "capitalize",
          fontFamily:  '"Montserrat", serif',
          color: "#000",
        }),
        singleValue: (provided) => ({
          ...provided,
          fontSize: "16px",
          textTransform: "capitalize",
          fontWeight: 700,
          direction: forceEnglishFont ? "ltr" : undefined,
          fontFamily: '"Montserrat", serif',
          color: "#000",
        }),
        placeholder: (provided) => ({
          ...provided,
          fontSize: "16px",
          textTransform: "capitalize",
          fontWeight: 600,
          color: "#6f6f6f",
          fontFamily:  '"Montserrat", serif',
        }),
        menu: (provided) => ({
          ...provided,
          zIndex: 9999,
        }),
        indicatorSeparator: () => ({
          display: "none",
        }),
      }}
    />
    {/* {errorMessage && <p className="error-text">{errorMessage}</p> } */}
    </>
  );
};

export default SelectDropdown;
